import { Alert } from "antd"
import { FC } from "react"

export const ErrorAlert: FC<{ error: string | null }> = ({ error }) => {
  if (error === null) {
    return null
  }
  return <Alert type="error" message={error} closable />
}
